<div class="sg-scrim" *ngIf="prompt" (click)="cancel()">
  <div class="sg-panel" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
    <div class="sg-head">
      <div>
        <span class="sg-move">{{ prompt.fromLabel ? prompt.fromLabel + ' → ' : 'Move to ' }}{{ prompt.toLabel }}</span>
        <h3>{{ prompt.requirement.title }}</h3>
        <p class="sg-desc" *ngIf="prompt.requirement.description">{{ prompt.requirement.description }}</p>
        <p class="sg-count" *ngIf="prompt.recordUuids.length > 1">These answers are saved on all {{ prompt.recordUuids.length }} records you're moving.</p>
      </div>
      <button type="button" class="sg-x" (click)="cancel()" aria-label="Cancel"><i class="bi bi-x-lg"></i></button>
    </div>

    <form class="sg-body" (ngSubmit)="submit()" novalidate>
      <ng-container *ngFor="let i of prompt.requirement.items">
        <ng-container *ngIf="shown(i)">
          <div class="sg-info" *ngIf="i.type === 'info'"><i class="bi bi-info-circle"></i> {{ i.message || i.label }}</div>

          <div class="sg-field" *ngIf="i.type !== 'info'" [class.has-error]="errors[i.key]">
            <label>{{ i.label }}<span class="sg-req" *ngIf="i.required"> *</span></label>

            <textarea *ngIf="i.type === 'note' || i.type === 'textarea'" class="sg-input" rows="3" [name]="i.key" [(ngModel)]="answers[i.key]"
                      [placeholder]="i.type === 'note' ? 'Add a note…' : ''"></textarea>
            <input *ngIf="['text','number','date'].includes(i.type)" class="sg-input" [type]="i.type" [name]="i.key" [(ngModel)]="answers[i.key]" />
            <input *ngIf="i.type === 'datetime'" class="sg-input" type="datetime-local" [name]="i.key" [(ngModel)]="answers[i.key]" />

            <select *ngIf="i.type === 'select'" class="sg-input" [name]="i.key" [(ngModel)]="answers[i.key]">
              <option value="">- Select -</option>
              <option *ngFor="let o of i.options" [value]="o">{{ o }}</option>
            </select>

            <div class="sg-choices" *ngIf="i.type === 'radio' || i.type === 'yes_no'">
              <label class="sg-choice" *ngFor="let o of (i.type === 'yes_no' ? ['Yes', 'No'] : i.options)">
                <input type="radio" [name]="i.key" [value]="o" [(ngModel)]="answers[i.key]" /> {{ o }}
              </label>
            </div>

            <div class="sg-choices" *ngIf="i.type === 'checkboxes' || i.type === 'checklist'">
              <label class="sg-choice" *ngFor="let o of (i.type === 'checklist' ? i.checklist : i.options)">
                <input type="checkbox" [checked]="answers[i.key]?.includes(o)" (change)="toggle(i.key, o!, $any($event.target).checked)" /> {{ o }}
              </label>
            </div>

            <small class="sg-help" *ngIf="i.help">{{ i.help }}</small>
            <small class="sg-err" *ngIf="errors[i.key]">{{ errors[i.key] }}</small>
          </div>
        </ng-container>
      </ng-container>

      <p class="sg-error" *ngIf="error">{{ error }}</p>
      <div class="sg-actions">
        <button type="button" class="btn" (click)="cancel()" [disabled]="saving">Cancel - don't move</button>
        <button type="submit" class="btn btn-primary" [disabled]="saving">{{ saving ? 'Saving…' : 'Save and move' }}</button>
      </div>
    </form>
  </div>
</div>
